
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g8HdwO8pGLdauFytkciF1pKWDQcSu9fonUQ7ECHoUasgMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexSR1Xj_454uUEKgQJIMJPfqDh1njnwz78OHXdrY1np7ugUMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchnBstHo_R7nX668f7H4yYrYDg3Y29H5W84lE0PsLEExAMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexOhtww0pYyXTBvx3T_4527o8hDHvYPlGeDCPYNVIYObgS0Meta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93ftp1KytOSYeTI17Y0JzOStBg5blPB_457V2MDHCEpezr8Meta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexXlC78QQxnYObzeTDaZVMDEBkNpHviH_4iLvRZk9gx4UMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93FyZz_QEIRIkfM1pjslnVg0JdGJgpjC7gAZHKF3BGpJYMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexEy4ntvPI2T9JVbuE8m6htm_liK8D0SN6twyMVEjTb_45wMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93IcpfmRaIgT1OG3PiuqhCFrgXd6X10ENyCnMsao5CyOkMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index5_459filH8IOaxI4ZCxadnpMuLsoszCwGOcrvU5V3l5TYMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexjmXVwJYmsUHul1JyYZF_jBibzjefpqGI4Z6Ld3ZE1DkMeta } from "/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexXlC78QQxnYObzeTDaZVMDEBkNpHviH_4iLvRZk9gx4UMeta || {},
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexEy4ntvPI2T9JVbuE8m6htm_liK8D0SN6twyMVEjTb_45wMeta || {},
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index5_459filH8IOaxI4ZCxadnpMuLsoszCwGOcrvU5V3l5TYMeta || {},
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexjmXVwJYmsUHul1JyYZF_jBibzjefpqGI4Z6Ld3ZE1DkMeta || {},
    component: () => import("/codebuild/output/src2581667917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]